import Header from "./components/Header";
import Hero from "./components/Hero";
import FlashSection from "./components/FlashSection";
import TodaySection from "./components/TodaySection";
import RankCommunity from "./components/RankCommunity";
import TrustFaq from "./components/TrustFaq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Header />
      <main>
        <Hero />
        <FlashSection />
        <TodaySection />
        <RankCommunity />
        <TrustFaq />
      </main>
      <Footer />
    </div>
  );
}